import React from "react";
import { ListaRelatorio } from "../../../../../Interfaces/Automacao/Regua/RelatorioDeEnvioRegua/RelatorioDeEnvioReguaInterfaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFrown } from "@fortawesome/free-solid-svg-icons";

interface IVisualizarRelatorioModalProps {
    setShow: (show: boolean) => void;
    row: ListaRelatorio;
}

export default function VisualizarRelatorioModal(
    props: IVisualizarRelatorioModalProps
) {
    return (
        <>
            <div className="text-center mb-10">
                {props.row.DS_CONTEUDO_ENVIADO ? (
                    <>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: props.row.DS_CONTEUDO_ENVIADO,
                            }}
                        ></div>
                    </>
                ) : (
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <FontAwesomeIcon
                            icon={faFrown}
                            size="3x"
                            className="svg-icon svg-icon-md svg-icon-gray-500 mr-1 d-lg-flex mb-4"
                        />
                        <h2 className="font-weight-bold">
                            Nenhum conteúdo encontrado
                        </h2>
                    </div>
                )}
            </div>
        </>
    );
}
